import type { Arena, ConfigEntry, GameCard, Rarity } from '@/models'

const CARD_DEFS: [string, Rarity][] = [
  ['Ember Imp', 'Common'],
  ['Shield Rat', 'Common'],
  ['Bramble Archer', 'Common'],
  ['Mud Golem', 'Common'],
  ['Spark Wisp', 'Common'],
  ['Tin Soldier', 'Common'],
  ['Bog Lurker', 'Common'],
  ['Slingstone', 'Common'],
  ['Frost Hare', 'Rare'],
  ['Iron Boar', 'Rare'],
  ['Gale Dancer', 'Rare'],
  ['Cinder Witch', 'Rare'],
  ['Root Warden', 'Rare'],
  ['Static Hound', 'Rare'],
  ['Pearl Diver', 'Rare'],
  ['Ash Herald', 'Rare'],
  ['Storm Colossus', 'Epic'],
  ['Night Chorus', 'Epic'],
  ['Molten Carp', 'Epic'],
  ['Hollow Knight of Fen', 'Epic'],
  ['Mirror Saint', 'Epic'],
  ['Thorn Empress', 'Epic'],
  ['Grave Piper', 'Epic'],
  ['Sun Anchor', 'Legendary'],
  ['Void Antler', 'Legendary'],
  ['The Last Cartographer', 'Legendary'],
  ['Opal Tyrant', 'Legendary'],
  ['Whisper Engine', 'Legendary'],
  ['Bone Orchard', 'Legendary'],
  ['King of Rust', 'Legendary'],
]

const ELIXIR_BY_RARITY: Record<Rarity, number> = { Common: 2, Rare: 3, Epic: 4, Legendary: 5 }

export const CARDS: GameCard[] = CARD_DEFS.map(([name, rarity], i) => ({
  id: `card_${String(i + 1).padStart(3, '0')}`,
  name,
  rarity,
  elixir: ELIXIR_BY_RARITY[rarity] + (i % 2),
  damage: 90 + ((i * 137) % 620),
  hp: 380 + ((i * 251) % 2400),
  usage: Math.round(((i * 313) % 340) / 10 + 1.2),
  winRate: Math.round((420 + ((i * 173) % 190)) / 10) / 10 + 40,
}))

export const ARENAS: Arena[] = [
  {
    id: 'a1',
    name: 'Goblin Stadium',
    trophyMin: 0,
    trophyMax: 599,
    unlocks: 'Spark Wisp',
    players: 128_400,
  },
  {
    id: 'a2',
    name: 'Bone Pit',
    trophyMin: 600,
    trophyMax: 1199,
    unlocks: 'Bog Lurker',
    players: 96_120,
  },
  {
    id: 'a3',
    name: 'Barbarian Bowl',
    trophyMin: 1200,
    trophyMax: 1799,
    unlocks: 'Iron Boar',
    players: 74_880,
  },
  {
    id: 'a4',
    name: 'Spell Valley',
    trophyMin: 1800,
    trophyMax: 2399,
    unlocks: 'Cinder Witch',
    players: 51_300,
  },
  {
    id: 'a5',
    name: 'Builder Workshop',
    trophyMin: 2400,
    trophyMax: 2999,
    unlocks: 'Static Hound',
    players: 38_940,
  },
  {
    id: 'a6',
    name: 'Frozen Peak',
    trophyMin: 3000,
    trophyMax: 3599,
    unlocks: 'Storm Colossus',
    players: 24_610,
  },
  {
    id: 'a7',
    name: 'Jungle Arena',
    trophyMin: 3600,
    trophyMax: 4199,
    unlocks: 'Thorn Empress',
    players: 15_270,
  },
  {
    id: 'a8',
    name: 'Legendary Arena',
    trophyMin: 4200,
    trophyMax: 9999,
    unlocks: 'Sun Anchor',
    players: 6_845,
  },
]

export const ECONOMY: ConfigEntry[] = [
  { key: 'chest.silver.timer', label: 'Silver chest timer', value: '3', unit: 'h' },
  { key: 'chest.gold.timer', label: 'Gold chest timer', value: '8', unit: 'h' },
  { key: 'chest.magical.timer', label: 'Magical chest timer', value: '12', unit: 'h' },
  { key: 'reward.win.gold', label: 'Gold per win', value: '28' },
  { key: 'reward.crown.chest', label: 'Crowns for crown chest', value: '10' },
  { key: 'shop.epic.price', label: 'Epic card shop price', value: '2000', unit: 'gold' },
  { key: 'shop.legendary.price', label: 'Legendary shop price', value: '40000', unit: 'gold' },
  { key: 'season.pass.price', label: 'Season pass price', value: '499', unit: 'gems' },
]

export const MATCHMAKING: ConfigEntry[] = [
  { key: 'mm.trophy.band', label: 'Trophy matching band', value: '±180' },
  { key: 'mm.queue.timeout', label: 'Queue timeout', value: '12', unit: 's' },
  { key: 'mm.bot.fill.after', label: 'Bot fill after', value: '9', unit: 's' },
  { key: 'mm.level.weight', label: 'King level weight', value: '0.35' },
  { key: 'mm.rematch.block', label: 'Rematch block window', value: '30', unit: 'min' },
]
